module.exports = __webpack_public_path__ + "static/media/statsIco2.c7143f41.svg";